import { dateToKey } from 'segments/utils/helpers/dateToKey';

import { CoachesBooking } from '../store/types';

export const convertCoachesBookingsToTable = (coaches: CoachesBooking) => coaches.map((coach) => ({
  ...coach,
  key: dateToKey(coach.startTime),
}));
